module.exports = __webpack_public_path__ + "static/organization-0081407bd0675cedcfaf5dd59e897d2a.png";